/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

// ran this thru claudes code refactoring tool

// redesign this component to look more elegant and polished and accents
// and add a little more pizzaz to the menu items and add hover effects 
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy


// add code to create a drop down list from depositProducts and assing the selected product to depositProduct
// give me the relevant code with instructions to implement




import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { MdPayment, MdEmail } from 'react-icons/md';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import { FaPhoneVolume } from 'react-icons/fa6';

import { get_product_deposits, get_product_balances } from '../../store/reducers/homeReducer';
import { get_event_details } from '../../store/reducers/eventDetailsReducer';

import DiagnosticInfo from '../DiagnosticInfo';
import { formatPhoneNumber } from 'react-phone-number-input';
import { currencyFormat } from '../CurrencyFormat';
import GetSellerConfig from '../GetSellerConfig';

import config from '../../config';

// ---------------------------------------------------------------------------
// Sub-components
// ---------------------------------------------------------------------------

//sellerColorDark, sellerColorMedium, sellerColorLight,
const ContactRow = ({ 
    icon: Icon, children, sellerColorDark, sellerColorMedium, sellerColorLight,
    }) => (
    <div
        className="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 cursor-default
            hover:scale-[1.01] border-0 group"
        style={{ 
            backgroundColor: sellerColorLight,
            borderLeft: `6px solid ${sellerColorDark}`,
            borderColor: sellerColorDark,
        }}>
        <div
            className="flex items-center justify-center w-8 h-8 rounded-full shrink-0 transition-all duration-200
                group-hover:scale-110"
            style={{ 
                backgroundColor: sellerColorLight, 
                color: sellerColorDark 
            }}>
            <Icon className="text-[18px]" />
        </div>
        <span className="text-[14px] font-medium" style={{ color: sellerColorDark }}>
            {children}
        </span>
  </div>
);

// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------

const DepositsAndBalances = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    const { userInfo } = useSelector((state) => state.auth);
    const { depositProducts, balanceProducts } = useSelector((state) => state.home); 
    //console.log('depositProducts:', depositProducts);
    //console.log('balanceProducts:', balanceProducts);

    const [depositProduct, setDepositProduct] = useState({});
    const [balanceProduct, setBalanceProduct] = useState({});
    
    //const [selectedItemsOtherEventOptions, setSelectedItemsOtherEventOptions] = useState([]);
    //console.log(depositProducts);
    const { eventDetails } = useSelector((state) => state.eventDetails);
    //console.log(eventDetails);
    const {
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerPhoneNumber, sellerCompanyEmailAddress,sellerBoolShowSiteChat, sellerBoolShowSitePayments,
    } = GetSellerConfig();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleDepositProductChange = (e) => {
        const selectedDepositProduct = depositProducts.find(p => p._id === e.target.value);
        //depositProduct = selected;
        //console.log(depositProduct);
        if (selectedDepositProduct) setDepositProduct(selectedDepositProduct);
        //dispatch(set_deposit_product(selectedDepositProduct));
    };
    const handleBalanceProductChange = (e) => {
        const selectedBalanceProduct = balanceProducts.find(p => p._id === e.target.value);
        // //depositProduct = selected;
        // //console.log(depositProduct);
        if (selectedBalanceProduct) setBalanceProduct(selectedBalanceProduct);
        // //dispatch(set_deposit_product(selectedDepositProduct));
    };

    useEffect(() => {
        dispatch(get_product_deposits(sellerFrontendURL));
        if (userInfo?.id) {
            dispatch(get_event_details(userInfo.id));
            dispatch(get_product_balances(userInfo.id));
        }
    }, [dispatch, sellerFrontendURL, userInfo?.id]);

    if (!depositProduct) return null;

    const handleChatClick = () =>
        navigate(userInfo ? '/customerDashboard/chat/About Giving A Deposit' : '/login');

    const handleDepositBuyNow = () => {
        const cartPayload = [
            {
                sellerId: depositProduct.sellerId,
                shopName: depositProduct.shopName,
                price: depositProduct.price,
                products: [{ quantity: 1, productInfo: depositProduct }],
            },
        ];
        //console.log(cartPayload);
        navigate('/eventDetails', {
            state: {
                products: cartPayload,
                price: depositProduct.price,
                shipping_fee: 0,
                items: 1,
            },
        });
    };

    const handleBalanceBuyNow = () => {
        const cartPayload = [
            {
                sellerId: balanceProduct.sellerId,
                shopName: balanceProduct.shopName,
                price: balanceProduct.price,
                products: [{ quantity: 1, productInfo: balanceProduct }],
            },
        ];
        // //console.log(cartPayload);
        navigate('/eventDetails', {
            state: {
                products: cartPayload,
                price: balanceProduct.price,
                shipping_fee: 0,
                items: 1,
            },
        });
    };

    const depositAlreadyGiven = Boolean(eventDetails?.depositGiven);
    const balanceAlreadyPaid = Boolean(eventDetails?.balancePaid);

    return (
        <div className="rounded-2xl bg-white overflow-hidden">
            <div
                className="rounded-2xl p-4 overflow-hidden"
                style={{
                    background: sellerColorLight,
                    border: `1px solid ${sellerColorDark}`,
                    borderTopWidth: '1px'
                }}>
                {/* Top accent bar */}
                <div
                    className="hidden h-[3px] w-full"
                    style={{
                    //background: `linear-gradient(90deg, ${colorDark} 0%, ${colorMedium} 60%, ${colorLight} 100%)`,
                    }}
                />

                <div className="">
                    {/* Header */}
                    <div className="flex items-center gap-2.5 mb-4">
                        <div className='text-2xl font-bold flex gap-1 mb-2'
                            style={{ color: sellerColorDark }}>
                            <MdPayment size={34} className='' /> Deposits & Balances
                        </div>    
                    </div>
                    <DiagnosticInfo parentPage={'DepositsAndBalances.jsx'} />
                    {/* Product selector */}
                    {depositProducts?.length > 1 && (
                        <div className="mb-4">
                            <label
                                htmlFor="deposit-product-select"
                                className="block text-[12px] uppercase tracking-widest font-semibold mb-1.5"
                                style={{ color: sellerColorMedium }}>
                                Select Deposit
                            </label>
                            <select
                                id="deposit-product-select"
                                value={depositProduct?._id ?? ''}
                                onChange={handleDepositProductChange}
                                className="w-full max-w-[380px] h-[44px] px-3 rounded-xl text-[15px] font-medium
                                    border-2 bg-white cursor-pointer
                                    focus:outline-none focus:ring-2 focus:ring-offset-1 transition-colors duration-150"
                                style={{
                                    borderColor: sellerColorDark,
                                    color: sellerColorDark,
                                }}>
                                <option value="">Select Deposit</option>
                                {depositProducts.map((p) => (
                                    <option key={p._id} value={p._id}>
                                        {p.name} — {currencyFormat.format(p.price)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    {/* === Deposit NOT yet given === */}
                    {!depositAlreadyGiven && depositProduct?.price > 0 && (
                        <div className="flex flex-col gap-3">
                            {/* CTA Button — gradient fill with lift */}
                            <button
                                onClick={handleDepositBuyNow}
                                aria-label={`Give deposit of ${currencyFormat.format(depositProduct.price)}`}
                                className="group relative flex items-center justify-center gap-2 h-[44px] px-5
                                    rounded-xl text-[18px] font-semibold text-white w-full max-w-[280px]
                                    transition-all duration-200 ease-out
                                    hover:-translate-y-[2px] hover:shadow-lg active:translate-y-0 active:shadow-sm
                                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                                style={{
                                    background: `linear-gradient(135deg, ${sellerColorDark} 0%, ${sellerColorDark} 100%)`,
                                    boxShadow: `0 2px 8px ${sellerColorMedium}`,
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = `0 6px 20px ${sellerColorMedium}`;
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = `0 2px 8px ${sellerColorMedium}`;
                                }}>
                                <MdPayment className="text-[24px] shrink-0" />
                                Give Deposit&nbsp;
                                <span className="font-bold">{currencyFormat.format(depositProduct?.price)}</span>
                            </button>

                            {/* Description */}
                            {depositProduct.description && (
                                <div
                                    className="text-[15px] font-semibold leading-snug uppercase"
                                    style={{ color: sellerColorDark }}>
                                    {depositProduct.description}
                                </div>
                            )}

                            {/* Note */}
                            <div
                                className="text-[14px] leading-relaxed max-w-sm px-3 py-2.5 border rounded-xl uppercase"
                                style={{
                                    backgroundColor: sellerColorLight,
                                    color: sellerColorDark,
                                    borderLeft: `6px solid ${sellerColorDark}`,
                                    borderColor: sellerColorDark,
                                }}>
                                Please contact us before giving the deposit to confirm that we can accommodate
                                your party&nbsp;/&nbsp;simcha.
                            </div>

                            {/* Divider */}
                            <div className="h-px w-full my-1" style={{ backgroundColor: sellerColorMedium }} />

                            {/* Contact section */}
                            <div
                                className="text-[11px] uppercase tracking-widest font-semibold mb-1"
                                style={{ color: sellerColorMedium }}>
                                Contact Us
                            </div>

                            <div className="flex flex-col gap-2">
                                {/* Chat */}
                                {sellerBoolShowSiteChat && (
                                    <button
                                        onClick={handleChatClick}
                                        className="flex items-center gap-3 px-3 py-2.5 rounded-xl w-full text-left
                                        transition-all duration-200 hover:scale-[1.01] group
                                        bg-transparent border-0 cursor-pointer"
                                        style={{
                                            backgroundColor: sellerColorLight,
                                            color: sellerColorDark,
                                            borderLeft: `6px solid ${sellerColorDark}`,
                                            borderColor: sellerColorDark,
                                        }}>
                                        <div
                                            className="flex items-center justify-center w-8 h-8 rounded-full shrink-0
                                                transition-all duration-200 group-hover:scale-110"
                                            style={{
                                                backgroundColor: sellerColorLight,
                                                color: sellerColorDark,
                                            }}>
                                            <IoChatbubbleEllipsesOutline className="text-[20px]" />
                                        </div>
                                        <span
                                            className="text-[14px] font-medium group-hover:underline underline-offset-2"
                                            style={{ color: sellerColorDark }}>
                                            Chat With Us
                                        </span>
                                        <span
                                            className="ml-auto text-[11px] px-2 py-0.5 rounded-full font-medium"
                                            style={{
                                                backgroundColor: sellerColorLight,
                                                color: sellerColorDark,
                                            }}>
                                            Online
                                        </span>
                                    </button>
                                )}

                                <ContactRow icon={FaPhoneVolume} sellerColorDark={sellerColorDark} 
                                    sellerColorMedium={sellerColorMedium} sellerColorLight={sellerColorLight}>
                                    {sellerPhoneNumber ? formatPhoneNumber(sellerPhoneNumber) : '—'}
                                </ContactRow>

                                <ContactRow icon={MdEmail}  sellerColorDark={sellerColorDark} 
                                    sellerColorMedium={sellerColorMedium} sellerColorLight={sellerColorLight}>
                                    {sellerCompanyEmailAddress}
                                </ContactRow>
                            </div>
                        </div>
                    )}

                    {/* === Deposit already given === */}
                    {depositAlreadyGiven && (
                        <div className="flex flex-col gap-3">
                            {/* Confirmed badge */}
                            <div className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-green-100 border border-green-700">
                                <div
                                    className="flex items-center justify-center w-8 h-8 rounded-full shrink-0 bg-green-200 border 
                                    border-green-600">
                                    <MdPayment className="text-[16px] text-green-700" />
                                </div>
                                <div>
                                    <p className="text-[11px] uppercase tracking-widest font-semibold text-green-700 leading-none mb-0.5">
                                        Deposit Confirmed
                                    </p>
                                    <p className="text-[18px] font-bold text-green-700 leading-none">
                                        {currencyFormat.format(eventDetails?.depositAmountPaid)}
                                    </p>
                                </div>
                            </div>

                            <Link
                                to="/customerDashboard/myOrders"
                                className="inline-flex items-center gap-1.5 text-[14px] font-semibold
                                    hover:underline underline-offset-2 transition-colors duration-150 w-fit"
                                style={{ color: sellerColorDark }}>
                                View My Orders →
                            </Link>
                        </div>
                    )}
                
                    {balanceProducts?.length > 0 && (
                        <div className="mb-4">
                            <label
                                htmlFor="balance-product-select"
                                className="block text-[12px] uppercase tracking-widest font-semibold mb-1.5"
                                style={{ color: sellerColorMedium }}>
                                Select Balance
                            </label>
                            <select
                                id="balance-product-select"
                                value={depositProduct?._id ?? ''}
                                onChange={handleBalanceProductChange}
                                className="w-full max-w-[380px] h-[44px] px-3 rounded-xl text-[15px] font-medium
                                    border-2 bg-white cursor-pointer
                                    focus:outline-none focus:ring-2 focus:ring-offset-1 transition-colors duration-150"
                                style={{
                                    borderColor: sellerColorDark,
                                    color: sellerColorDark,
                                }}>
                                <option value="">Select Balance</option>
                                {balanceProducts.map((p) => (
                                    <option key={p._id} value={p._id}>
                                        {p.name} — {currencyFormat.format(p.price)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    {/* === Balance NOT yet paid !depositAlreadyGiven &&  === */}
                    {balanceProduct?.price > 0 && (
                    <div className="flex flex-col gap-3">
                        {/* CTA Button — gradient fill with lift */}
                        <button
                            onClick={handleBalanceBuyNow}
                            aria-label={`Pay Balance of ${currencyFormat.format(balanceProduct.price)}`}
                            className="group relative flex items-center justify-center gap-1 h-[44px] px-5
                                rounded-xl text-[18px] font-semibold text-white w-full max-w-[340px]
                                transition-all duration-200 ease-out
                                hover:-translate-y-[2px] hover:shadow-lg active:translate-y-0 active:shadow-sm
                                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                            style={{
                                background: `linear-gradient(135deg, ${sellerColorDark} 0%, ${sellerColorDark} 100%)`,
                                boxShadow: `0 2px 8px ${sellerColorMedium}`,
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = `0 6px 20px ${sellerColorMedium}`;
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = `0 2px 8px ${sellerColorMedium}`;
                            }}>
                            <MdPayment className="text-[24px] shrink-0" />
                            Pay Balance&nbsp;
                            <span>{currencyFormat.format(balanceProduct?.price)}</span>
                        </button>

                        {/* Description */}
                        {balanceProduct.description && (
                            <div
                                className="text-[15px] font-semibold leading-snug uppercase"
                                style={{ color: sellerColorDark }}>
                                {balanceProduct.description}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    </div>
  );
};

export default DepositsAndBalances;





//refactored
// import React, { useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { MdPayment, MdEmail } from 'react-icons/md';
// import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
// import { FaPhoneVolume } from 'react-icons/fa6';

// import { get_product_deposit_details } from '../../store/reducers/homeReducer';
// import { get_event_details } from '../../store/reducers/eventDetailsReducer';

// import { formatPhoneNumber } from 'react-phone-number-input';
// import { currencyFormat } from '../CurrencyFormat';
// import GetSellerConfig from '../GetSellerConfig';

// import config from '../../config';

// // ---------------------------------------------------------------------------
// // Small sub-components
// // ---------------------------------------------------------------------------

// const ContactRow = ({ icon: Icon, children, className = '' }) => (
//   <div className={`flex items-center mt-1 gap-2 ${className}`}>
//     <Icon className="text-[18px] shrink-0" />
//     <span>{children}</span>
//   </div>
// );

// // ---------------------------------------------------------------------------
// // Main component
// // ---------------------------------------------------------------------------

// const GiveDeposit = () => {
//   const IS_DEV = config.STR_ENVIRONMENT === 'Dev';
//   const sellerFrontendURL = config.STR_FRONTEND_URL;

//   // --- Redux state ---
//   const { userInfo } = useSelector((state) => state.auth);
//   const { depositProduct } = useSelector((state) => state.home);
//   const { eventDetails } = useSelector((state) => state.eventDetails);

//   // --- Seller config ---
//   const {
//     // Colors
//     sellerPrimaryColor1,
//     sellerSecondaryColor1,
//     // Contact
//     sellerPhoneNumber,
//     sellerCompanyEmailAddress,
//     // Feature flags
//     sellerBoolShowSiteChat,
//     sellerBoolShowSitePayments,
//   } = GetSellerConfig();

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // Fetch data on mount; include stable deps to avoid stale-closure warnings
//   useEffect(() => {
//     dispatch(get_product_deposit_details(sellerFrontendURL));
//     if (userInfo?.id) {
//       dispatch(get_event_details(userInfo.id));
//     }
//   }, [dispatch, sellerFrontendURL, userInfo?.id]);

//   // Guard: deposit product may not be loaded yet
//   if (!depositProduct) {
//     return null; // or a skeleton/spinner
//   }

//   // --- Handlers ---
//   const handleChatClick = () => {
//     navigate(
//       userInfo
//         ? '/customerDashboard/chat/About Giving A Deposit'
//         : '/login'
//     );
//   };

//   const handleBuyNow = () => {
//     const cartPayload = [
//       {
//         sellerId: depositProduct.sellerId,
//         shopName: depositProduct.shopName,
//         price: depositProduct.price,
//         products: [{ quantity: 1, productInfo: depositProduct }],
//       },
//     ];

//     navigate('/eventDetails', {
//       state: {
//         products: cartPayload,
//         price: depositProduct.price,
//         shipping_fee: 0,
//         items: 1,
//       },
//     });
//   };

//   // --- Derived ---
//   const themeStyle = {
//     backgroundColor: sellerSecondaryColor1,
//     color: sellerPrimaryColor1,
//     borderColor: sellerPrimaryColor1,
//   };

//   const depositAlreadyGiven = Boolean(eventDetails?.depositGiven);

//   // ---------------------------------------------------------------------------
//   // Render
//   // ---------------------------------------------------------------------------
//   return (
//     <div>
//       <div className="border p-4 rounded-md" style={themeStyle}>
//         {/* Header */}
//         <div className="text-2xl font-bold flex items-center gap-2 mb-2">
//           <MdPayment />
//           Give Deposit
//         </div>

//         {/* === Deposit NOT yet given === */}
//         {!depositAlreadyGiven && (
//           <div className="flex flex-col gap-2">
//             <button
//               onClick={handleBuyNow}
//               aria-label={`Give deposit of ${currencyFormat.format(depositProduct.price)}`}
//               className="px-3 py-1 flex h-[34px] w-[250px] text-[16px] justify-center items-center
//                          rounded-lg font-semibold cursor-pointer hover:shadow-lg
//                          hover:shadow-green-500/40 text-white transition-shadow"
//               style={{ backgroundColor: sellerPrimaryColor1 }}
//             >
//               <MdPayment className="mr-2 text-[24px]" />
//               Give Deposit {currencyFormat.format(depositProduct.price)}
//             </button>

//             {depositProduct.description && (
//               <span className="text-[18px] font-semibold" style={{ color: sellerPrimaryColor1 }}>
//                 {depositProduct.description}
//               </span>
//             )}

//             <p className="w-full max-w-sm text-[15px]">
//               Please contact us before you give the deposit to make sure that we
//               can accommodate your party/simcha.
//             </p>

//             {/* Chat — only shown when feature flag is on */}
//             {sellerBoolShowSiteChat && (
//               <button
//                 onClick={handleChatClick}
//                 className="flex items-center gap-2 mt-1 cursor-pointer hover:underline w-fit bg-transparent border-0 p-0"
//                 style={{ color: sellerPrimaryColor1 }}
//               >
//                 <IoChatbubbleEllipsesOutline className="text-[22px]" />
//                 Chat With Us
//               </button>
//             )}

//             <ContactRow icon={FaPhoneVolume}>
//               Call Us:{' '}
//               {sellerPhoneNumber ? formatPhoneNumber(sellerPhoneNumber) : '—'}
//             </ContactRow>

//             <ContactRow icon={MdEmail}>
//               Email Us: {sellerCompanyEmailAddress}
//             </ContactRow>
//           </div>
//         )}

//         {/* === Deposit already given === */}
//         {depositAlreadyGiven && (
//           <div>
//             <div className="text-xl font-semibold text-green-600">
//               Deposit Given: {currencyFormat.format(depositProduct.price)}
//             </div>
//             <div className="mt-2">
//               <Link
//                 to="/customerDashboard/myOrders"
//                 className="text-xl font-semibold hover:underline"
//                 style={themeStyle}
//               >
//                 For More Details, View My Orders
//               </Link>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GiveDeposit;



//my original code
// import React, { useEffect, useState }  from 'react';
// import {  useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { MdOutlineRestaurantMenu, MdPayment, MdOutlineTableBar, MdEmail } from "react-icons/md";
// import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
// import { FaPhoneVolume } from "react-icons/fa6";

// import { get_product_deposit_details } from '../../store/reducers/homeReducer';
// import { get_event_details, messageClear } from '../../store/reducers/eventDetailsReducer';

// import { formatPhoneNumber } from 'react-phone-number-input'
// import { currencyFormat } from '../CurrencyFormat';
// import GetSellerConfig from '../GetSellerConfig';

// import config from '../../config';

// const GiveDeposit = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerEnvironment = config.STR_ENVIRONMENT

//     const { userInfo } = useSelector(state => state.auth)
//     const { depositProduct } = useSelector(state => state.home)
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);

//     //const { seller } = useSelector(state => state.seller)

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
//         sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
//         sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber,
//         sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
//         sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
//         personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,

//         sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
//         sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, sellerBoolShowSitePayments
//     } = GetSellerConfig();


//     const navigate = useNavigate();
//     const dispatch = useDispatch()
    
//     useEffect(() => {
//         dispatch(get_product_deposit_details(sellerFrontendURL)) //slug is productId
//         dispatch(get_event_details(userInfo.id))
//     },[])

//     const redirect_chat_page = () => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/About Giving A Deposit`)
//             ///${sellerId}/customerDashboard/chat/${chatTopic}
//         } else {
//             navigate('/login')
//         }
//     }

//     const buy_it_now_local = () => {
//         // section 83 buy it now
//         let price = depositProduct.price; //0;
//         // if (product.discount !== 0) {
//         //     price = product.price - Math.floor((product.price * product.discount) / 100)
//         // } else {
//         //     price = product.price
//         // }

//         const obj = [
//             {
//                 sellerId: depositProduct.sellerId,
//                 shopName: depositProduct.shopName,
//                 price :  depositProduct.price, //quantity * (price - Math.floor((price * 5) / 100)),
//                 products : [
//                     {
//                         quantity: 1,
//                         productInfo: depositProduct
//                     }
//                 ]
//             }
//         ]
    
//         navigate('/eventDetails',{
//             state: {
//                 products : obj,
//                 price: price, // * quantity,
//                 shipping_fee : 0,
//                 items: 1
//             }
//         }) 
//     }
    
//     return (
//         <div>
//             <div className='border p-4 rounded-md'
//                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                 <div className='text-2xl font-bold flex gap-1 mb-2 '>
//                     <MdPayment className='mt-1 mr-1' /> Give Deposit
//                 </div>
//                 <div className={` ${sellerEnvironment === 'Dev' ? '' : 'hidden'} text-[14px]`}>
//                     <div>eventDetails?._id</div>
//                     <div>"_id": ObjectId("{eventDetails?._id}")</div>
//                     <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//                     <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments.toString()}</div>
//                 </div>
//                 {
//                     !eventDetails?.depositGiven &&
//                     <div>
//                         <button onClick={buy_it_now_local}
//                             className='px-3 py-1 flex h-[34px] w-[250px] text-[16px] justify-center items-center rounded-lg 
//                             font-semibold cursor-pointer hover:shadow-lg hover:shadow-green-500/40 text-white'
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             <MdPayment className='mr-2 text-[24px]'/>Give Deposit {currencyFormat.format(depositProduct.price)}
//                         </button> 
//                         <span className='text-[18px] font-semibold' style={{color:sellerPrimaryColor1}}>
//                             {depositProduct.description}
//                         </span>       
//                         <div className='w-[50%]'>
//                             Please contact us before you give the deposit to make sure that we can accommodate your party/simcha.
//                         </div>
//                         <div onClick={redirect_chat_page} className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
//                             mt-2 flex cursor-pointer`}>
//                             <IoChatbubbleEllipsesOutline className='text-[22px] mr-2'/>
//                             Chat With Us
//                         </div>
//                         <div className='flex mt-1'>
//                             <FaPhoneVolume className='text-18px] mt-1 mr-3'/>
//                             Call Us: {formatPhoneNumber(sellerPhoneNumber)}
//                         </div>
//                         <div className='flex mt-1'>
//                             <MdEmail className='text-28px] mt-1 mr-3'/> 
//                             Email Us: {sellerCompanyEmailAddress}
//                         </div>
//                     </div>
//                 }
//                 {
//                     eventDetails?.depositGiven && 
//                     <div>
//                         <div className='text-xl font-semibold text-green-600'>
//                             Deposit Given: {currencyFormat.format(depositProduct.price)}
//                         </div>
//                         <div className='mt-2'>
//                             <Link to='/customerDashboard/myOrders' className='text-xl font-semibold hover:underline'
//                                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                 For More Details, View My Orders
//                             </Link>
//                         </div>
//                     </div>
//                 }
//             </div>
//         </div>
//     );
// };

// export default GiveDeposit;





